var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportClaim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Report_Claim_2",
    "data-name": "Report_Claim 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 98.53 98.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .report_Claim-1 {\n        fill: #fff;\n        stroke: #3c5572;\n        stroke-miterlimit: 10;\n        stroke-width: 6px;\n      }\n\n      .report_Claim-2 {\n        fill: #3c5572;\n        font-family: AcuminConcept-CondBlack, 'Acumin Variable Concept';\n        font-size: 56.61px;\n        font-variation-settings: 'wght' 800, 'wdth' 67, 'slnt' 0;\n        font-weight: 800;\n        letter-spacing: .2em;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Report_Claim_1",
    "data-name": "Report Claim 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "report_Claim-1",
    cx: 49.27,
    cy: 49.27,
    r: 46.27
  }), /*#__PURE__*/React.createElement("text", {
    className: "report_Claim-2",
    transform: "translate(41.34 65.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "!"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportClaim);
export default __webpack_public_path__ + "static/media/ReportClaim.f43d5c55b9be8a2ea0254e98213e7d2e.svg";
export { ForwardRef as ReactComponent };